import React from 'react';
import styled from 'styled-components';
import { Section, Container, BlockTitle, RichText } from '../styles/shared';

const TextContent = styled.div`
  max-width: ${({ $maxWidth }) => $maxWidth || '800px'};
  margin: ${({ $align }) => $align === 'center' ? '0 auto' : undefined};
  text-align: ${({ $align }) => $align || 'left'};
`;

const TextBlock = ({ content = {}, settings = {} }) => {
  const { content: html = '', title = '', alignment = 'left', maxWidth = '800px' } = content;
  const { backgroundColor = '', padding = 'medium', textColor = '' } = settings;
  return (
    <Section $padding={padding} $bgColor={backgroundColor} $textColor={textColor}>
      <Container>
        <TextContent $align={alignment} $maxWidth={maxWidth}>
          {title && <BlockTitle>{title}</BlockTitle>}
          <RichText dangerouslySetInnerHTML={{ __html: html }} />
        </TextContent>
      </Container>
    </Section>
  );
};

export default TextBlock;
